import * as React from 'react';
import classNames from 'classnames';

import { onClear } from '../../../utils';
import { Input } from './Input';

/**
 * Renders an input text field, complete with label and help text.
 */
export class InputTextField extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { active: false, focused: false };
        onClear(this);
        this.onFocus = () => this.setState({ focused: true });
        this.onBlur = () => this.setState({ focused: false });
    }

    render() {
        const {
            value,
            name: key,
            onChange,
            allowClear,
            fixedLabel = false,
            icon,
            label,
            theme = 'light',
            status: currentStatus,
            disabled = false,
            InputComponent = Input,
            helpText,
            className,
            required,
            ...props
        } = this.props;
        const { focused } = this.state;
        const requiredTxt = required ? ' *' : '';
        return (
            <React.Fragment>
                <div
                    className={classNames(
                        'text-field',
                        className,
                        currentStatus === 'error' && 'text-field--error',
                        currentStatus === 'valid' && 'text-field--valid',
                        fixedLabel && 'text-field--fixed-label',
                        icon && 'text-field--has-icon',
                        disabled && 'text-field--is-disabled',
                        `text-field--theme-${theme}`,
                        value !== null && value !== undefined && 'text-field--has-value',
                        ((value !== null && value !== undefined) || focused) && 'text-field--is-active',
                        focused && 'text-field--is-focus',
                    )}
                >
                    {icon && (
                        <div className="text-field__icon">
                            <i className={`mdi mdi-${icon}`} />
                        </div>
                    )}
                    <label className="text-field__label">{label}{requiredTxt}</label>
                    <InputComponent
                        {...props}
                        value={value}
                        name={key}
                        onChange={onChange}
                        disabled={disabled}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        className="text-field__input"
                    />
                    {allowClear && (
                        <span className="text-field__clear" onClick={this.onClear}>
                            <i className="mdi mdi-close-circle" />
                        </span>
                    )}
                </div>
                {helpText && (
                    <span className={`text-field-${currentStatus === 'error' ? 'error' : 'help'}`}>{helpText}</span>
                )}
            </React.Fragment>
        );
    }
}
